import examCourseService from './course'

export default {
	namespaced:true,
	modules: {
		course: examCourseService
	}
}